import { type IClientProperties } from '@/interfaces'

export class ClientProperties implements IClientProperties {
	newClient: boolean
	marketingAgency: boolean
	poRequired: boolean
	clientIntakeForm: boolean
	paymentRemittance: boolean
	arStatement: boolean
	collections: boolean
	minorityOwned: boolean
	womanOwned: boolean
	smallBusiness: boolean

	constructor({
		newClient = false,
		marketingAgency = false,
		poRequired = false,
		clientIntakeForm = false,
		paymentRemittance = false,
		arStatement = false,
		collections = false,
		minorityOwned = false,
		womanOwned = false,
		smallBusiness = false
	}: Partial<IClientProperties> = {}) {
		this.newClient = newClient
		this.marketingAgency = marketingAgency
		this.poRequired = poRequired
		this.clientIntakeForm = clientIntakeForm
		this.paymentRemittance = paymentRemittance
		this.arStatement = arStatement
		this.collections = collections
		this.minorityOwned = minorityOwned
		this.womanOwned = womanOwned
		this.smallBusiness = smallBusiness
	}
}
